<div
  *ngIf="parentFormGroup.controls[controlName]"
  class="component-container"
>
  <div
    class="form-field-label {{type}}"
    *ngIf="label"
  >
    {{label}}
    <span
      *ngIf="isRequired"
      class="required-mark"
    >*</span>
  </div>
  <div class="bp-input-container flex flex-row w-full items-center">
    <mat-form-field
      [formGroup]="form"
      appearance="outline"
      class="form-field w-[47%]"
      [ngClass]="type ? 'small':''"
      hideRequiredMarker
    >
      <input
        class="input {{type}} number-input"
        formControlName="sys"
        matInput
        [placeholder]="formPlaceholders.sys"
        maxlength="3"
        type="text"
        onlyDigit
      >
    </mat-form-field>
    <div class="form-field w-[6%] text-center">/</div>
    <mat-form-field
      [formGroup]="form"
      appearance="outline"
      class="form-field w-[47%]"
      [ngClass]="type ? 'small':''"
      hideRequiredMarker
    >
      <input
        class="input {{type}} number-input"
        formControlName="dia"
        matInput
        [placeholder]="formPlaceholders.dia"
        maxlength="3"
        type="text"
        onlyDigit
      >
    </mat-form-field>
  </div>
  <div
    class="error-container flex flex-col justify-start w-full">
    <mat-error class="{{type}}"
               *ngIf="error">{{error}}</mat-error>
    <p *ngIf="showWarning" class="warning {{type}}">
      Please double check the
      blood pressure you
      entered and
      confirm they are correct.
    </p>
  </div>
</div>
